import { useState } from 'react'
import { savedCreditCardApis } from '../Services/Apis'
import { get } from 'lodash'
import { CreditCardHelper } from 'Helpers/CreditCardHelper'
import { runInAction } from 'mobx'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import storeUser from 'GlobalStores/User/StoreUser'

export function useCreditcardAliases() {
    const [savedCreditCards, setSavedCreditCards] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [apiSaveResponse, setApiSaveResponse] = useState(null)

    const [creditCard, setCreditCard] = useState({
        card_number: '',
        exp_date: '',
        name_on_card: '',
        cvv: ''
    })

    const fetchSavedCreditCards = async callback => {
        try {
            if (loading) return
            setLoading(true)
            const response = await savedCreditCardApis.getSavedCreditCards({ userCountry: storeUser.CustomerData().MainAddress().country })
            setSavedCreditCards(response.data)
            runInAction(() => {
                storeCheckout.savedCardAlias = response.data
            })
            callback && callback(response.data)
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const deleteCreditCard = async ({ number, callback }) => {
        try {
            setLoading(true)
            await savedCreditCardApis.deleteSavedCreditCard({ cardAlias: number, userCountry: storeUser.CustomerData().MainAddress().country })
            callback && callback(true)
            setLoading(false)
        } catch (error) {
            callback && callback(false, get(error, 'response.data.error.error_message', []))
            setLoading(false)
        }
    }

    const handleSave = async ({ cardNumber, expiryDate, nameOnCard, cvv, callback, userCountry }) => {
        setLoading(true)
        setError(null)
        try {
            const validateCard = CreditCardHelper.cardValidate({
                countryCode: userCountry,
                creditCard: {
                    creditCardNumber: cardNumber,
                    creditCardExpires: expiryDate,
                    creditCardSecurityCode: cvv,
                    payer: nameOnCard
                }
            })

            if (!validateCard.success) {
                setError(validateCard.error_messages)
                return
            }

            const methodDetails = {
                methodDetails: {
                    alias: cardNumber.slice(0, 5) + 'xxxxxx' + cardNumber.slice(-4),
                    creditCardNumber: cardNumber,
                    creditCardExpires: `${Number(expiryDate.split('/')[1]) + 2000}-${expiryDate.split('/')[0]}`,
                    payer: nameOnCard,
                    billToAddress: {
                        country: userCountry
                    }
                },
                billToAddress: {
                    country: userCountry
                }
            }
            const response = await savedCreditCardApis.saveCreditCard({ methodDetails, userCountry: userCountry })
            setApiSaveResponse(response)
            setCreditCard({
                card_number: cardNumber,
                exp_date: expiryDate,
                name_on_card: nameOnCard,
                cvv: cvv
            })
            callback && callback()
        } catch (error) {
            console.error(error)
            if (get(error, 'response.data.error')) {
                setError(get(error, 'response.data.error.error_message'))
            }
        } finally {
            setLoading(false)
        }
    }

    return { savedCreditCards, loading, fetchSavedCreditCards, handleSave, error, creditCard, setCreditCard, deleteCreditCard, apiSaveResponse }
}
